import React from 'react';
import DataProtectionLayout from './data-protection-layout';

export default class DataProtection extends React.Component<{}, {}> {
    render() {
        return (
            <DataProtectionLayout />
        )
    }
}